import Constants from "expo-constants";
import { Link } from "expo-router";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

const BADGE_HEIGHT = 40;

export default function AppStoreBadgeLink() {
    const { t, i18n } = useTranslation();

    const language = i18n.language;

    return (
        <View className="m-8 items-center">
            <Text className="text-xs text-muted-foreground">
                {t("login.getTheAppOnYourPhone")}
            </Text>
            <View className="m-3 flex-row justify-center gap-x-6">
                <Link
                    href={`https://apps.apple.com/app/basis-prague/id${
                        Constants.expoConfig!.extra!.appStoreApplicationId
                    }`}
                >
                    <img
                        src={`/images/App_Store_Badge_${language === "cs" ? "CZ" : "US"}.svg`}
                        alt={t("login.downloadOnTheAppStore")}
                        height={BADGE_HEIGHT}
                        style={{ height: BADGE_HEIGHT, width: "auto" }}
                    />
                </Link>
                <Link href={Constants.expoConfig!.extra!.playStoreUrl}>
                    <img
                        src={`/images/GetItOnGooglePlay_Badge_Web_color_${language === "cs" ? "Czech" : "English"}.svg`}
                        alt={t("login.getItOnGooglePlay")}
                        height={BADGE_HEIGHT}
                        style={{ height: BADGE_HEIGHT, width: "auto" }}
                    />
                </Link>
            </View>
        </View>
    );
}
